import { CancelTokenSource } from 'axios';
import { FeedLiveItem } from '@/models/feedLive';
import { FeedPregameItem } from '@/models/feedPregame';

export const useSearchStore = defineStore('search', () => {
    const items = shallowRef<(FeedLiveItem | FeedPregameItem)[]>([]);
    const searchQuery = ref<string>('');
    const externalSearchQuery = ref<string>('');
    const ajaxRequest = ref<CancelTokenSource>();

    return {
        items,
        searchQuery,
        externalSearchQuery,
        ajaxRequest,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useSearchStore, import.meta.hot));
}
